/**
 * @file Sums the received amount of the investments into the capital invested, in dollars.
 */
import { INVESTMENT_STATUS } from "@components/Domain";
import { getFormattedAmountValue, getFormattedDecimalValue } from "@components/Amount";

type Investment = {
  status?: string;
  receivedAmount?: number;
};

/**
 * Sums the received amount in cents of each investment that is not rejected, and returns the total in dollars.
 * The received amount carries the conversion of a transferred investment, so the total matches Backstage.
 */
const getCapitalInvested = (investments: Investment[] = []): number => {
  const receivedAmount = investments
    .filter(({ status }) => status !== INVESTMENT_STATUS.REJECTED)
    .map(({ receivedAmount: amount = 0 }) => amount)
    .reduce((total, amount) => getFormattedDecimalValue(total, amount, "plus"), 0);

  const capitalInvested = getFormattedAmountValue(receivedAmount);

  return capitalInvested;
};

export default getCapitalInvested;
